import { NotificationDTO } from "./notifications.dto";
import { Notifications } from "../notifications.entity";
import { Injectable } from "@nestjs/common";

@Injectable()
export class NotificationAdapter{

    public convertDtoToEntity(dto: NotificationDTO, isUpdate: boolean = false): Notifications{
        console.log(dto,'status')
        const entity = new Notifications();
        entity.notificationId = dto.notificationId;
        entity.jobRole = dto.jobRole;
        entity.plant = dto.plant;
        entity.plantId=dto.plantId;
        entity.jobDescription = dto.jobDescription;
        entity.notificationDate = dto.notificationDate;
        entity.resourceRequired = dto.resourceRequired;
        entity.skills = dto.skills;
        entity.yearOfExperience = dto.yearOfExperience;
        entity.plannedClosingDate = dto.plannedClosingDate;
        entity.remarks = dto.remarks;
        entity.status = dto.status;
        
        entity.isActive = dto.isActive == undefined ? true : dto.isActive;
        if(isUpdate){
            entity.updatedUser = dto.updatedUser;
            
        }else {
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: Notifications): NotificationDTO{
        const dto = new NotificationDTO();
        dto.notificationId = entity.notificationId;
        dto.plant = entity.plant;
        dto.plantId=entity.plantId;
        dto.jobRole = entity.jobRole;
        dto.jobDescription = entity.jobDescription;
        dto.notificationDate = entity.notificationDate;
        dto.resourceRequired = entity.resourceRequired;
        dto.skills = entity.skills;
        dto.yearOfExperience = entity.yearOfExperience;
        dto.plannedClosingDate = entity.plannedClosingDate;
        dto.remarks = entity.remarks;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        dto.status = entity.status;
      
        return dto;
    }
}